export enum UserCategory {
  Student = 'Student',
  Lecturer = 'Lecturer',
}
